var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirthdayCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 70,
    viewBox: "0 0 96 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.046 14.425C23.546 12.525 25.046 10.025 25.746 9.125C25.846 8.925 26.146 8.925 26.246 9.125C26.846 10.025 28.446 12.525 28.946 14.425C30.646 13.325 31.846 11.325 31.846 9.025C31.846 6.525 28.746 2.525 27.146 0.525C26.546 -0.175 25.546 -0.175 25.046 0.525C23.346 2.525 20.346 6.525 20.346 9.025C20.146 11.325 21.346 13.325 23.046 14.425Z",
    fill: "url(#paint0_linear_13610_268806)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2461 16.825C22.1461 16.825 21.2461 17.725 21.2461 18.825V30.325H30.8461V18.825C30.8461 17.725 29.9461 16.825 28.8461 16.825H23.2461Z",
    fill: "#A0AEC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1475 14.425C45.6475 12.525 47.1475 10.025 47.8475 9.125C47.9475 8.925 48.2475 8.925 48.3475 9.125C48.9475 10.025 50.5475 12.525 51.0475 14.425C52.7475 13.325 53.9475 11.325 53.9475 9.025C53.9475 6.525 50.8475 2.525 49.2475 0.525C48.6475 -0.175 47.6475 -0.175 47.1475 0.525C45.4475 2.525 42.4475 6.525 42.4475 9.025C42.2475 11.325 43.4475 13.325 45.1475 14.425Z",
    fill: "url(#paint1_linear_13610_268806)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3477 16.825C44.2477 16.825 43.3477 17.725 43.3477 18.825V30.325H52.9477V18.825C52.9477 17.725 52.0477 16.825 50.9477 16.825H45.3477Z",
    fill: "#A0AEC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2468 14.425C67.7468 12.525 69.2468 10.025 69.9468 9.125C70.0468 8.925 70.3468 8.925 70.4468 9.125C71.0468 10.025 72.6468 12.525 73.1468 14.425C74.8468 13.325 76.0468 11.325 76.0468 9.025C76.0468 6.525 72.9468 2.525 71.3468 0.525C70.7468 -0.175 69.7468 -0.175 69.2468 0.525C67.5468 2.525 64.5468 6.525 64.5468 9.025C64.3468 11.325 65.4468 13.325 67.2468 14.425Z",
    fill: "url(#paint2_linear_13610_268806)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3477 16.825C66.2477 16.825 65.3477 17.725 65.3477 18.825V30.325H74.9477V18.825C74.9477 17.725 74.0477 16.825 72.9477 16.825H67.3477Z",
    fill: "#A0AEC0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3469 63.025H87.8469V53.425C86.8469 53.325 85.7469 52.925 84.8469 52.325L82.0469 50.325C81.0469 49.625 79.6469 49.625 78.6469 50.325L75.8469 52.325C73.7469 53.825 70.8469 53.825 68.7469 52.325L65.9469 50.325C64.9469 49.625 63.5469 49.625 62.5469 50.325L59.7469 52.325C57.6469 53.825 54.7469 53.825 52.6469 52.325L49.8469 50.325C48.8469 49.625 47.4469 49.625 46.4469 50.325L43.6469 52.325C41.5469 53.825 38.6469 53.825 36.5469 52.325L33.7469 50.325C32.7469 49.625 31.3469 49.625 30.3469 50.325L27.5469 52.325C25.4469 53.825 22.5469 53.825 20.4469 52.325L17.6469 50.325C16.6469 49.625 15.2469 49.625 14.2469 50.325L11.4469 52.325C10.5469 52.925 9.54688 53.325 8.54688 53.425V63.025H3.74687C1.94687 63.025 0.546875 64.525 0.546875 66.225C0.546875 68.025 2.04687 69.425 3.74687 69.425H92.2469C94.0469 69.425 95.4469 67.925 95.4469 66.225C95.5469 64.425 94.0469 63.025 92.3469 63.025Z",
    fill: "url(#paint3_linear_13610_268806)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1473 47.625C14.2473 46.125 17.1473 46.125 19.2473 47.625L22.0473 49.625C23.0473 50.325 24.4473 50.325 25.4473 49.625L28.2473 47.625C30.3473 46.125 33.2473 46.125 35.3473 47.625L38.1473 49.625C39.1473 50.325 40.5473 50.325 41.5473 49.625L44.3473 47.625C46.4473 46.125 49.3473 46.125 51.4473 47.625L54.2473 49.625C55.2473 50.325 56.6473 50.325 57.6473 49.625L60.4473 47.625C62.5473 46.125 65.4473 46.125 67.5473 47.625L70.3473 49.625C71.3473 50.325 72.7473 50.325 73.7473 49.625L76.5473 47.625C78.6473 46.125 81.5473 46.125 83.6473 47.625L86.4473 49.625C86.7473 49.825 87.1473 50.025 87.5473 50.025V45.725C87.5473 38.925 82.0473 33.425 75.2473 33.425H20.2473C13.4473 33.425 7.94727 38.925 7.94727 45.725V50.025C8.34727 49.925 8.64727 49.825 9.04727 49.625L12.1473 47.625Z",
    fill: "url(#paint4_linear_13610_268806)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13610_268806",
    x1: 26.0851,
    y1: 0,
    x2: 26.0851,
    y2: 14.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FBBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#957115"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13610_268806",
    x1: 48.1867,
    y1: 0,
    x2: 48.1867,
    y2: 14.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FBBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#957115"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13610_268806",
    x1: 70.2851,
    y1: 0,
    x2: 70.2851,
    y2: 14.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FBBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#957115"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13610_268806",
    x1: 0.546875,
    y1: 59.6125,
    x2: 95.4516,
    y2: 59.6125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78350F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE621C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13610_268806",
    x1: 47.7473,
    y1: 33.425,
    x2: 47.7473,
    y2: 50.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FBBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#957115"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayCake);
export default __webpack_public_path__ + "static/media/Birthday_Cake.6f2665c2decd6f16ab3e2e1214491d7d.svg";
export { ForwardRef as ReactComponent };